export { default as LoyaltyQuickPayWidget } from './loyalty-quick-pay-widget';
